module.exports = __webpack_public_path__ + "img/c667c70.jpg";